<template>
	<div tag="article" class="c-search-list-layout">
		<PageHeader
			ref="header"
			:intro="{ image: null }"
			layout="list"
			class="z-20 relative"
		>
			<!-- Custom header content -->
			<template v-if="$scopedSlots.customHeader" #custom>
				<slot name="customHeader"></slot>
			</template>
		</PageHeader>

		<div id="cludo-category-facet"></div>

		<div id="cludo-search-results" class="cludo-search-results">
			<div
				class="
					cludo-search-results__facets
					search-filters
					cludo-search-controls
				"
				aria-controls="search-results"
			></div>

			<div class="cludo-search-results__layout">
				<div class="cludo-search-results__results-wrapper">
					<div
						id="search-results"
						class="cludo-search-results__results search-results"
						role="region"
						aria-live="polite"
						:aria-label="
							language === 'da'
								? 'Søgeresultater'
								: 'Search results'
						"
					></div>

					<div id="cludo-load-more" class="cludo-hidden">
						<button type="button">
							{{ language === 'da' ? 'Vis flere' : 'Show more' }}
						</button>
					</div>

					<div id="cludo-back-to-top" class="cludo-hidden">
						<button type="button">
							{{
								language === 'da'
									? 'Tilbage til toppen'
									: 'Back to top'
							}}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '~/components/main/PageHeader';

export default {
	name: 'SearchListLayout',

	components: {
		PageHeader,
	},
	inheritAttrs: false,

	computed: {
		language() {
			return this.$store.state?.site?.culture.split('-')[0] || 'da';
		},
	},
};
</script>

<style lang="postcss">
.c-search-list-layout:before {
	@apply bg-gray-light;
	content: '';
	display: block;
	position: fixed;
	left: -50vw; /* for some reason blur triggers weird stuff if just 0 0 and 100vw and vh */
	top: 0;
	width: 200vw;
	height: calc(
		100vh + 9999999px
	); /* and for some reason the blur cuts the bottom of the page if just 100vh / treats it as semi-absolute? */
	z-index: -1;
}
</style>
